import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function AdminLayout() {
  return (
    <div className="adm-shell">
      <Sidebar />
      <div className="adm-main">
        <TopBar />
        <main className="adm-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
